import '@ui5/webcomponents/dist/ResponsivePopover.js';
import { PopoverHorizontalAlign, PopoverPlacementType, PopoverVerticalAlign } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `ResponsivePopover` acts as a Popover on desktop and tablet, while on phone it acts as a Dialog. The component improves tremendously the user experience on mobile.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/ResponsivePopover" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const ResponsivePopover = withWebComponent('ui5-responsive-popover', [
    'headerText',
    'horizontalAlign',
    'opener',
    'placementType',
    'verticalAlign',
    'accessibleName',
    'accessibleNameRef',
    'initialFocus'
], ['allowTargetOverlap', 'hideArrow', 'hideBackdrop', 'modal', 'open', 'preventFocusRestore'], ['footer', 'header'], ['after-close', 'after-open', 'before-close', 'before-open']);
ResponsivePopover.displayName = 'ResponsivePopover';
ResponsivePopover.defaultProps = {
    horizontalAlign: PopoverHorizontalAlign.Center,
    placementType: PopoverPlacementType.Right,
    verticalAlign: PopoverVerticalAlign.Center
};
export { ResponsivePopover };
